module.exports = __webpack_public_path__ + "img/sxly.8b81b8f5.jpg";